import { create } from "zustand";
import { lastSelectedUserLangLSKey } from "variables/localStorageItemsNames";
import { currentPage } from "scrivito";
import { initLocalsStore } from "./localsStore";
import { getProductActions, getProductInput } from "stores/product";

type UseGlobalStore = {
  language: string;
  isSameProj: boolean;
  setLanguage: (language: string) => void;
  init: () => void;
};

const useGlobalStore = create<UseGlobalStore>((set) => ({
  language: "en",
  isSameProj: false,
  setLanguage: (language) => set({ language }),
  init: () => {
    let language = localStorage.getItem(lastSelectedUserLangLSKey);
    if (!language) {
      const scrivitoList = currentPage()?.get("categoryLanguages");
      if (
        scrivitoList &&
        Array.isArray(scrivitoList) &&
        scrivitoList.length > 0 &&
        typeof scrivitoList[0] === "string"
      ) {
        language = scrivitoList[0];
      }
    }
    if (!language) {
      language = "de";
    }

    const isSameProj =
      currentPage()?.path()?.startsWith("/same") ||
      process?.env?.REACT_APP_IS_SAME === "true";
    set({ language, isSameProj });
  },
}));

export const useLanguage = () => useGlobalStore((state) => state.language);
export const useIsSameProj = () => useGlobalStore((state) => state.isSameProj);
export const useSetLanguage = () => {
  const setLanguage = useGlobalStore((state) => state.setLanguage);
  return (language: string) => {
    setLanguage(language);
    if (getProductInput()) {
      getProductActions().sync();
    }
    initLocalsStore();
  };
};
export const initGlobalStore = () => useGlobalStore.getState().init();

export const getLanguage = () => useGlobalStore.getState().language;
